export const ADVANCE_TIMEFRAME_OPTIONS = [
    { value: 'pay-period', label: 'pay cycle' },
    { value: 'month', label: 'month' },
    { value: 'week', label: 'week' },
    { value: 'day', label: 'day' }
];

export const CAP_RULE_TAB_KEYS = {
    TENURE: 'tenure',
    PRODUCT_TYPES: 'product-types',
    GEOGRAPHY: 'geography',
};

export const CAP_RULE_TABS = [
    { key: CAP_RULE_TAB_KEYS.TENURE, label: 'Tenure' },
    { key: CAP_RULE_TAB_KEYS.PRODUCT_TYPES, label: 'Product Types' },
    { key: CAP_RULE_TAB_KEYS.GEOGRAPHY, label: 'Geography' },
];

/**
 * The product-type / geography lists of each cap: the `limit_policy` key the
 * service reads, the field a row matches on, and a new row's starting value
 * (the same as the cap's tenure rows).
 */
export const CAP_RULE_LISTS = {
    advanceCapProductTypeRules: { apiKey: 'advance_cap_product_type_rules', matchKey: 'productType', defaultValue: 5 },
    advanceCapGeographyRules: { apiKey: 'advance_cap_geography_rules', matchKey: 'states', defaultValue: 5 },
    volumeCapProductTypeRules: { apiKey: 'volume_cap_product_type_rules', matchKey: 'productType', defaultValue: 500 },
    volumeCapGeographyRules: { apiKey: 'volume_cap_geography_rules', matchKey: 'states', defaultValue: 500 },
};
